import React from 'react';
import { PlanCard } from '~/types/models/plasmic';

export interface PricingFooterProps
  extends Pick<PlanCard, 'image' | 'bottomBorderColor'> {}

export function PricingFooter({
  image,
  bottomBorderColor,
}: PricingFooterProps) {
  return (
    <div className='flex flex-col w-full absolute bottom-0'>
      <img src={image?.url} className='block h-[170px] w-full bottom-[5px]' />
      {bottomBorderColor && (
        <span
          className='block h-[5px] w-full rounded-b-md bottom-0 left-0'
          style={{ backgroundColor: bottomBorderColor }}
        />
      )}
    </div>
  );
}
